var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBell = function SvgBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    fillRule: "evenodd",
    d: "M13.21 3.217C13.21 2.545 12.668 2 12 2s-1.21.545-1.21 1.217v2.365c-2.546.185-4.686.97-6.311 2.358-1.883 1.609-2.983 3.95-3.284 6.85-.149 1.428 1.024 2.518 2.334 2.518h16.942c1.31 0 2.483-1.09 2.335-2.518-.301-2.9-1.402-5.24-3.284-6.85-1.626-1.388-3.765-2.173-6.312-2.358zM21.79 22c.668 0 1.21-.545 1.21-1.217 0-.673-.542-1.218-1.21-1.218H2.21c-.668 0-1.21.545-1.21 1.218S1.542 22 2.21 22z",
    clipRule: "evenodd"
  })));
};
export default SvgBell;